<template>
    <v-group :config="{ ...groupConfig }">
        <template v-for="l in layers">
            <template v-if="isVisible(l)">
                <text-bundled 
                v-if="l.type==='Text'"
                :key="l.id"
                :layer="{ ...l }"
                :artworkID="artworkID"
                :scale="scale"
                :offset="offset"
                :parentRatio="parentRatio"
                :rotation="rotation"
                :personalized="personalized"
                :artworks="artwork"
                />
                <image-bundled 
                v-if="l.type === 'Image'"
                :layer="l"
                :key="l.id"
                :artworkID="artworkID"
                :scale="scale"
                :offset="offset"
                :parentRatio="parentRatio"
                :rotation="rotation"
                :personalized="personalized"
                />
                <group-bundled
                v-if="l.type === 'Group'"
                :layer="l"
                :key="l.id"
                :artworkID="artworkID"
                :scale="scale"
                :offset="offset"
                :parentRatio="parentRatio"
                :rotation="rotation"
                :personalized="personalized"
                :artworks="artwork"
                />
            </template>
        </template>
    </v-group>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'
import { checkCondition, isMoonColorVisible } from '@/helper/helper'
import ImageBundled from './ImageBundled';
import TextBundled from './TextBundled';
export default {
    name: "group-bundled",
    components: {ImageBundled, TextBundled},
    props: {
        layer: {
            type: Object,
            default() {
                return null
            }
        },
        offset: {
            type: Object
        },
        scale: {
            type: Number,
            default() {
                return 1
            }
        },
        artworkID: {
            type: String,
            required: true
        },
        parentRatio: {
            type: Number,
            default() {
                return 1
            }
        },
        rotation: {
            type: Number,
            default() {
                return 0
            }
        },
        personalized: {
            type: Object,
            default(){
            return {}
            }
        },
        artworks: {
            required: true
        },
    },
    created(){
    },
    computed: {
        groupConfig() {
            var config = {
                ...this.layer
            }
            var scaleProps = ['x', 'y', 'width', 'height']
            scaleProps.forEach(key => {
                if (config[key]) {
                config[key] = config[key] * this.scale
                }
            })
            return config
        },
        layers() {
            return get(this.layer, 'layers', [])
        },
        artwork() {
            const { artworks, artworkID } = this
            if('length' in artworks){
                return artworks.find(art => art.id === artworkID)
            }else{
                return artworks
            }
            
        },
        template() {
            const { artwork, personalized } = this
            return get(personalized, `${artwork.id}.template`, 0)
        },
        templateLayers() {
            const { template, artwork } = this
            return artwork.templates[template].layers
        }
    },
    methods: {
       checkCondition(layer) {
            const { templateLayers, personalized, artworkID } = this
            const data = get(personalized, artworkID)
            return checkCondition(layer, data, templateLayers)
        },
        isVisible(layer) {
            if (
                get(layer, 'personalized.enable', false) !== true &&
                layer.excludeMockup === true
            ) {
                return false
            }
            const { templateLayers, personalized, artworkID } = this
            const data = get(personalized, artworkID)
            return this.checkCondition(layer) && isMoonColorVisible(layer, templateLayers, data)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BundledProduct/ArtworkBundled/GroupBundled.vue